export const browserRoutes = {
  // auth
  login: "/login",
  createAccount: "/create-account",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  profile: "/profile",
  changePassword: "/change-password",
  // dashboard
  dashboard: "/dashboard",
  // events
  events: "/events",
  addEvents: "/events/add",
  editEvents: "/events/edit",
  viewEvents: "/events/view",
  addPhtotoVedio: "/events/add-photo-vedio",
  addEditTimeSlot: "/events/add-edit-time-slot",
  // users
  users: "/users",
  viewUser: "/users/view",

  vehicle: "/vehicle",
  addVehicle: "/vehicle/add",
  editVehicle: "/vehicle/edit",
  viewVehicle: "/vehicle/view",

  // Vehical brand
  brand: "/vehicleBrand",
  addBrand: "/vehicleBrand/add",
  editBrand: "/vehicleBrand/edit",
  viewBrand: "/vehicleBrand/view",
  viewBrandModels: "/vehicleBrand/view/models",

  // rides
  rides: "/rides",
  viewRides: "/rides/view",
  // groups
  clubs: "/clubs",
  addClub: "/clubs/add",
  editClub: "/clubs/edit",
  viewClub: "/clubs/view",

  // faq
  faqs: "/faqs",
  addFaq: "/faqs/add",
  editFaq: "/faqs/edit",
  deleteFaq: "/faqs/delete",

  // interest
  interest: "/interest",
  addInterest: "/interest/add",
  editInterest: "/interest/edit",
  deleteInterest: "/interest/delete",
  // tags
  tags: "/tags",

  //highlights
  highlight: "/highlights",

  //contact us
  contactUs: "/contact-us",

  //category
  category: "/category",

  //facility
  facility: "/facility",

  // static page
  staticPage: "/static-page",
  editStaticPage: "/static-page/edit",

  //Notification
  notification: "/notification",

  // Public pages
  privacyPolicy: "/privacy-policy",
  termsAndConditions: "/terms-and-conditions",
  stickerVerificationHistory: "/sticker-verification-history",
};
